import { Reducer, Action } from 'redux'
import { ILogsState, IVersion, IRequestData } from 'types/logs'
import { LOGS_ACTION_TYPES, LOGS_COUNT_ACTION_TYPES } from '../actions/logs'

const { LOGS_FAILURE, LOGS_REQUEST, LOGS_SUCCESS } = LOGS_ACTION_TYPES
const { LOGS_COUNT_FAILURE, LOGS_COUNT_REQUEST, LOGS_COUNT_SUCCESS } = LOGS_COUNT_ACTION_TYPES

interface LogsRequestAction extends Action<string> {
  payload: {
    requestData: IRequestData
  }
}

interface LogsSuccessAction extends Action<string> {
  payload: {
    nextPage: boolean
    requestData: IRequestData
    versions: IVersion[]
  }
}

interface LogsCountSuccessAction extends Action<string> {
  payload: {
    count: number
  }
}

interface LogsErrorAction extends Action<string> {
  error: string
}

type LogsAction =
  | Action<string>
  | LogsRequestAction
  | LogsSuccessAction
  | LogsErrorAction
  | LogsCountSuccessAction

const defaultState = {
  firstLoad: true,
  fetching: false,
  hasNextPage: false,
  versions: [],
  params: {
    pageCount: 0,
  },
  count: 0,
  fetchingCount: false,
} as ILogsState

const logsReducer: Reducer<ILogsState, LogsAction> = (state = defaultState, action) => {
  if (!action) return state

  switch (action.type) {
    case LOGS_REQUEST: {
      const {
        payload: {
          requestData: { params },
        },
      } = action as LogsRequestAction
      return {
        ...state,
        fetching: true,
        error: undefined,
        params,
      }
    }
    case LOGS_SUCCESS: {
      const {
        payload: {
          nextPage,
          requestData: { params },
          versions,
        },
      } = action as LogsSuccessAction
      return {
        ...state,
        firstLoad: false,
        fetching: false,
        error: undefined,
        versions,
        params,
        hasNextPage: nextPage,
      }
    }
    case LOGS_FAILURE: {
      return {
        ...state,
        firstLoad: false,
        fetching: false,
        error: (action as LogsErrorAction).error,
      }
    }
    case LOGS_COUNT_REQUEST: {
      return {
        ...state,
        fetchingCount: true,
        countError: undefined,
      }
    }
    case LOGS_COUNT_SUCCESS: {
      return {
        ...state,
        fetchingCount: false,
        count: (action as LogsCountSuccessAction).payload.count,
      }
    }
    case LOGS_COUNT_FAILURE: {
      return {
        ...state,
        fetchingCount: false,
        error: (action as LogsErrorAction).error,
      }
    }
    default:
      return state
  }
}

export default logsReducer
